module.exports = __webpack_public_path__ + "img/l3.8be51f42.jpg";